import { useForm } from '../../contexts/FormContext'
import { Button, Badge } from '../../components/common'
import './Step1SiteBase.css'

function Step1SiteBase() {
  const { formData, updateFormData, goToNextStep } = useForm()

  const handleSelect = (type) => {
    updateFormData({
      siteBase: type,
      costs: {
        ...formData.costs,
        setupTotal: type === 'basic' ? 75000 : 150000
      },
      timeline: {
        estimatedWeeks: type === 'basic' ? 2 : 3,
        estimatedDays: 0
      }
    })
  }

  return (
    <div className="step-section">
      {/* Section Header with Coral Background */}
      <div className="section-header">
        <h2>Step 1: Website Foundation</h2>
        <p className="section-subtitle">Select your package type</p>
      </div>

      {/* Section Body */}
      <div className="section-body">
        <div className="options-grid-2col">
          {/* Basic Option */}
          <div
            className={`option-card-compact ${formData.siteBase === 'basic' ? 'selected' : ''}`}
            onClick={() => handleSelect('basic')}
          >
            <Badge variant="success" className="option-badge-corner">
              Recommended
            </Badge>
            <h3 className="option-title">Basic Corporate Website</h3>
            <div className="option-price">¥75,000</div>
            <div className="option-timeline">2 WEEKS DELIVERY</div>
            <ul className="option-features-compact">
              <li>3 pages included</li>
              <li>Company presence</li>
              <li>Banking ready</li>
              <li>Payment gateway</li>
            </ul>
          </div>

          {/* Ecommerce Option */}
          <div
            className={`option-card-compact ${formData.siteBase === 'ecommerce' ? 'selected' : ''}`}
            onClick={() => handleSelect('ecommerce')}
          >
            <h3 className="option-title">Advanced Ecommerce Site</h3>
            <div className="option-price">¥150,000</div>
            <div className="option-timeline">3 WEEKS DELIVERY</div>
            <ul className="option-features-compact">
              <li>Full online shop</li>
              <li>Payment processing</li>
              <li>Product sales</li>
              <li>Subscription models</li>
            </ul>
          </div>
        </div>
      </div>

      {/* Section Actions */}
      <div className="section-actions">
        <div></div>
        <Button
          variant="primary"
          size="md"
          disabled={!formData.siteBase}
          onClick={goToNextStep}
        >
          Next Step
        </Button>
      </div>
    </div>
  )
}

export default Step1SiteBase
